export const checkProfileCompletion = (user) => {
  const profile = user?.attributes?.profile;
  const publicData = profile?.publicData;
  const privateData = profile?.privateData;
  const protectedData = profile?.protectedData;
  
  const userType = publicData?.userType;
  const missingFields = [];
  
  // Basic profile requirements for all users
  // Check if identification document exists (files are now in protectedData)
  const hasIdDocument = protectedData?.identificationDocument && 
    (protectedData.identificationDocument.name || 
     protectedData.identificationDocument.uploaded || 
     protectedData.identificationDocument.sharetribeImageId);
  const hasIdDocumentType = privateData?.idDocumentType;
  
  if (!hasIdDocument || !hasIdDocumentType) {
    missingFields.push('identificationVerification');
  }
  
  // Additional requirements for all service providers (event professionals)
  if (userType === 'eventpro') {
    const hasFoodHandlersCard = protectedData?.foodHandlersCard && 
      (protectedData.foodHandlersCard.name || 
       protectedData.foodHandlersCard.uploaded || 
       protectedData.foodHandlersCard.sharetribeImageId);
    const hasTitleIV = protectedData?.titleIVCertification && 
      (protectedData.titleIVCertification.name || 
       protectedData.titleIVCertification.uploaded || 
       protectedData.titleIVCertification.sharetribeImageId);
    const hasProofOfInsurance = protectedData?.proofOfInsurance && 
      (protectedData.proofOfInsurance.name || 
       protectedData.proofOfInsurance.uploaded || 
       protectedData.proofOfInsurance.sharetribeImageId);
      
    if (!hasFoodHandlersCard) {
      missingFields.push('foodHandlersCard');
    }
    if (!hasTitleIV) {
      missingFields.push('titleIVCertification');
    }
    if (!hasProofOfInsurance) {
      missingFields.push('proofOfInsurance');
    }
  }
  
  return {
    isComplete: missingFields.length === 0,
    missingFields,
    userType
  };
};

export const getProfileCompletionMessage = (missingFields, userType, intl) => {
  const messages = [];
  
  if (missingFields.includes('identificationVerification')) {
    messages.push(intl.formatMessage({ id: 'ProfileCompletion.identificationRequired' }));
  }
  
  if (missingFields.includes('foodHandlersCard')) {
    messages.push(intl.formatMessage({ id: 'ProfileCompletion.foodHandlersCardRequired' }));
  }
  
  if (missingFields.includes('titleIVCertification')) {
    messages.push(intl.formatMessage({ id: 'ProfileCompletion.titleIVRequired' }));
  }
  
  if (missingFields.includes('proofOfInsurance')) {
    messages.push(intl.formatMessage({ id: 'ProfileCompletion.proofOfInsuranceRequired' }));
  }
  
  return messages;
};
